import React, { useEffect } from "react";
import { alpha, useTheme } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";
import { Link as Link2 } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";

import Container from "Components/Container";

const Hero = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  useEffect(() => {
    const jarallaxInit = async () => {
      const jarallaxElems = document.querySelectorAll(".jarallax");
      if (!jarallaxElems || (jarallaxElems && jarallaxElems.length === 0)) {
        return;
      }

      const { jarallax } = await import("jarallax");
      jarallax(jarallaxElems, { speed: 0.2 });
    };

    jarallaxInit();
  });

  return (
    <Box
      className={"jarallax"}
      data-jarallax
      data-speed="0.2"
      position={"relative"}
      minHeight={{ xs: 390, sm: 500, md: 500 }}
      display={"flex"}
      alignItems={"center"}
      marginTop={-13}
      paddingTop={13}
      id="agency__portfolio-item--js-scroll"
      backgroundColor="#fdfaf5"
    >
      <Box
        className={"jarallax-img"}
        sx={{
          position: "absolute",
          objectFit: "cover",
          /* support for plugin https://github.com/bfred-it/object-fit-images */
          fontFamily: "object-fit: cover;",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
          backgroundRepeat: "no-repeat",
          backgroundSize: {
            xs: "auto 50%",
            sm: "auto 90%",
          },
          backgroundPosition: {
            xs: "70% 25%",
            sm: "70% -205%",
          },
          //backgroundImage: "url(/static/images/mainbg.webp)",
          backgroundImage: "url(/static/images/bloom-new-header.png)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: 1,
          height: 1,
          background: alpha("#161c2d", 0.1),
          zIndex: 1,
        }}
      />
      <Container position={"relative"} zIndex={2}>
        <Box maxWidth={{ xs: 1, sm: "40%" }}>
          <Typography
            variant="h2"
            color="white"
            gutterBottom
            sx={{
              fontWeight: 700,
            }}
          >
            A One-of-a-Kind Learning Center
          </Typography>
          <Typography
            variant="h6"
            color="white"
            component="p"
            sx={{ fontWeight: 600 }}
          >
            Now Open in Chino Hills
          </Typography>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "stretched", sm: "flex-start" }}
            marginTop={4}
          >
            <Button
              component={Link2}
              variant="yellow"
              color="primary"
              size="large"
              fullWidth={isMd ? false : true}
              to={"/our-philosophy"}
              sx={{ color: "black" }}
              endIcon={
                <Box
                  component={"svg"}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 31 31"
                  stroke="currentColor"
                  width={24}
                  height={24}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </Box>
              }
            >
              Learn About Our Philosophy
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
